import { SubmitErrorHandler, SubmitHandler } from "react-hook-form";

import { useProfilePageContext } from "../lib/context";
import { alertActions } from "../../../../features/alert/alertSlice";
import { updateUser } from "../../../../lib/api";
import { IUserProfileData } from "../../../../types/forms";

export const useFormHandlers = () => {
    const { dispatch } = useProfilePageContext();

    const onSubmit: SubmitHandler<IUserProfileData> = async data => {
        await updateUser(data)
            .then(() => {
                dispatch(
                    alertActions.success({
                        title: "Profile updated successfully",
                        dismissible: true,
                    }),
                );
            })
            .catch(e =>
                dispatch(
                    alertActions.error({
                        title: "The server encountered a problem updating your profile.",
                        text: "If the problem continues, please reach out to an admin.",
                        dismissible: true,
                    }),
                ),
            );
    };

    const onError: SubmitErrorHandler<IUserProfileData> = (data): void => {
        console.log(data);
    };

    return { onSubmit, onError };
};
